import React, { useCallback, useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { useFetch } from '../../../services/transports';
import { GetDemandIdListMP } from '../../../api/demandAndOffer';
import { LabeledSelect } from '..';

export const SearchDemandIds = ({
  label,
  id,
  onChange,
  withAsterisks,
  disabled,
  value,
  setValueAsObject = false,
  portal = 'mp', // Add portal prop with default
  ...props
}) => {
  const [t] = useTranslation();
  const [options, setOptions] = useState([]);
  const allOptionsRef = useRef([]);

  const [, fetchDemandIds] = useFetch(
    GetDemandIdListMP,
    useCallback(response => {
      // Handle the API response structure: response.data.container.rows
      const demandIdsArray = response?.data?.container?.rows;

      if (Array.isArray(demandIdsArray) && demandIdsArray.length > 0) {
        // Extract demandId from each object and convert to dropdown format
        const demandOptions = demandIdsArray
          .filter(item => item && item.demandId)
          .map(item => ({
            value: Math.floor(item.demandId), // Convert decimal to integer
            text: Math.floor(item.demandId).toString(),
            item: item
          }));
        
        allOptionsRef.current = demandOptions;
        setOptions(demandOptions);
      } else {
        allOptionsRef.current = [];
        setOptions([]);
      }
    }, [])
  );

  // Initial load - only for MP portal
  useEffect(() => {
    if (portal === 'mp') {
      fetchDemandIds();
    }
  }, [portal]); // Remove fetchDemandIds from dependencies to prevent infinite loop

  return (
    <LabeledSelect
      searchDelay={0}
      filterOption={true}
      allowClear
      placeholder={t('fields.choose')}
      label={label}
      id={id}
      onChange={onChange}
      value={value}
      showSearch
      withDebounceSearch={true}
      EmptyComponent={t('ERR.noMatchedDemandId')}
      options={options}
      withAsterisks={withAsterisks}
      disabled={disabled}
      {...props}
    />
  );
};
